import {CALL_MODE, ERROR_CATALOG,ALERT_CATALOG, HANG_UP_SUBACTIONS, SM_QUEUE_SERVER, STEP_MANUAL_CALL, ERROR_CATALOG_LIST, ALERT_CATALOG_LIST } from "../constants/constants";
import { MESSAGE_CODE, MESSAGE_FROM, MESSAGE_TYPE } from "../constants/Notifications";
import { requestPhoneNumber, triggerNotifications } from "../Helpers/helperMessages";


export const makeSvrManualCall = (that, phone, camId, callKey, data1) => {
    const phoneNumberValidate = that.sharedData.getGeneralPermissions()[206];
    const forceData1 = that.sharedData.getGeneralPermissions()[115];
    console.log(`The value of the setting 115 is ${forceData1}`);

    if (!camId) {
        const errorHandler = ERROR_CATALOG_LIST[1081];
        that.errorEvents.errorManualCall(errorHandler);
        return;
    }
    
    if(forceData1 === '1' && !data1)
    {
        const errorHandler = ERROR_CATALOG_LIST[ERROR_CATALOG.NO_DATA_FIELD];
        that.errorEvents.errorManualCall(errorHandler);
        return;
    }

    if(that.sharedData.lastIdCampManualCall !== camId)
    {
        that.sharedData.lastIdCampManualCall = camId;
        that.sharedData.watcherStatusCall = 0;
    }

    let objectResponse = that.apiCont.getObjectResponse();
    const objData = requestPhoneNumber(camId, phone, data1, that.sharedData.watcherStatusCall, callKey);
    that.apiCont.validatePhoneNumber(objData, objectResponse);
    objectResponse.onError = function (messageError) {
        if(messageError.Json.InternalCode === ALERT_CATALOG.CHECK_NUMBER || messageError.Json.InternalCode === ALERT_CATALOG.INCORRECT_NUMBER)
        {
            if(phoneNumberValidate==='1' || phoneNumberValidate==='2'){
                sendCallPackage(that, phone, camId, callKey, data1);
                return;
            }
            that.sharedData.watcherStatusCall = STEP_MANUAL_CALL.BLACKLIST_OR_WRONG_CAMP;
        }
        handleErrors(that,messageError);
    };
    objectResponse.onSuccess = function () {
        sendCallPackage(that, phone, camId, callKey, data1);
    };
}


const handleErrors = (that, messageError) =>
{
    const {Type, InternalCode} = messageError.Json;
    if(Type === 'ALERT')
    {
        const alertHandler = ALERT_CATALOG_LIST[InternalCode];
        that.errorEvents.warnManualCallPhoneLength(alertHandler);
    }
    else if(Type === 'ERROR')
    {
        const errorHandler = ERROR_CATALOG_LIST[InternalCode];
        that.errorEvents.errorManualCall(errorHandler);
    }
}



const sendCallPackage = (that, phone, camId, callKey, data1) => {
    if (that.sharedData.isAssistedMode) {
        callKey = that.sharedCallOutData.assistedCallKey;
        data1 = that.sharedCallOutData.assistedData1;
    } else {
        callKey ? callKey : "";
        data1 ? data1 : "";
    }
    const message = {
        action: "manualCall",
        username: that.sharedData.getUserData().Login,
        userID: that.sharedData.getUserData().User_id,
        CamId: parseInt(camId),
        CallKey: callKey,
        Phone: phone,
        Data: data1,
        ExistsCallout: 0,
        CallMode: CALL_MODE.MANUAL_CALL,
        integration: false,
        Odbc: 0,
        Ani: ""
    };
    that.sendToRabbit(SM_QUEUE_SERVER, message);
    that.sharedData.watcherStatusCall = STEP_MANUAL_CALL.FIRST_TRY;
    triggerNotifications(that, MESSAGE_CODE.CONNECTION_ALERTS[200], MESSAGE_TYPE.SUCCESS, MESSAGE_FROM.SDK);

}

export const svrHangUpManualCall = (that) =>{
    const message = {
        action: "HangUp",
        username: that.sharedData.getUserData().Login,
        userID: that.sharedData.getUserData().User_id,
        Subaction: HANG_UP_SUBACTIONS.MANUAL_CALL,
    };
    that.sendToRabbit(SM_QUEUE_SERVER, message);
}

export const svrCancelScheduledManualCall = (that) => {
    const { sharedData, svrEvents, sendToRabbit } = that;
    if (!sharedData.isManualCallScheduled) {
        svrEvents.onCancelScheduledManualCall({
            cancel: false,
            message: 'There is no scheduled manual call'
        });
        triggerNotifications(that, MESSAGE_CODE.MANUAL_CALL[10904], MESSAGE_TYPE.INFO, MESSAGE_FROM.SDK);
        return;
    }

    const { Login: username, User_id: userID } = sharedData.getUserData();
    const message = {
        action: "manualCall",
        username,
        userID,
        CamId: 0,
        CallKey: "",
        Phone: "",
        Data: "",
        ExistsCallout: 0,
        CallMode: CALL_MODE.MANUAL_CALL,
    };

    sendToRabbit(SM_QUEUE_SERVER, message);
    sharedData.isManualCallScheduled = false;
    svrEvents.onCancelScheduledManualCall({
        cancel: true,
        message: 'Scheduled manual call cancelled successfully'
    });
    triggerNotifications(that, MESSAGE_CODE.MANUAL_CALL[10903], MESSAGE_TYPE.WARN, MESSAGE_FROM.SDK);
};
